export const TariffSystem = {
  HS: 'HS',
  CN: 'CN',
  TARIC: 'TARIC',
  AHECC: 'AHECC'
};

export type TariffSystemType = (typeof TariffSystem)[keyof typeof TariffSystem];

export const TariffSystemLength: { [key: TariffSystemType]: number } = {
  HS: 6,
  CN: 8,
  TARIC: 10,
  AHECC: 8
};

export const TariffSystems = Object.values(TariffSystem);
